import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React from "react";
const CircularProgressLoader = () => {
    return (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }, children: _jsx(CircularProgress, {}) }));
};
export default CircularProgressLoader;
